import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Types, updateNewNotifications } from './actions';
import { users } from '~/helpers/api';

export function* getNewNotifications() {
  let result;
  try {
    result = yield call(users.getNewNotifications);
    yield put(updateNewNotifications(result.total));
  } catch (e) {
    result = e;
  }

  return result;
}

export default all([takeLatest(Types.REQUEST, getNewNotifications)]);
